export default "__VITE_ASSET__D_i4zTvG__"